import type { CurriculumObjectives } from '@interactive-room';

/** Quita el prefijo "OA 01:" del texto curricular para lectura en impresión. */
export function stripCurriculumCodePrefix(text: string): string {
  return String(text || '')
    .trim()
    .replace(/^(OA|OAH|OAA)\s*[A-Za-z0-9]+:\s*/i, '')
    .trim();
}

export function curriculumReferenceItems(objectives: CurriculumObjectives) {
  const items: Array<{ code: string; text: string }> = [];

  if (objectives.oaCode && objectives.objetivo) {
    items.push({ code: objectives.oaCode, text: stripCurriculumCodePrefix(objectives.objetivo) });
  }
  if (objectives.oahCode && objectives.habilidad) {
    items.push({ code: objectives.oahCode, text: stripCurriculumCodePrefix(objectives.habilidad) });
  }
  if (objectives.oaaCode && objectives.actitud) {
    items.push({ code: objectives.oaaCode, text: stripCurriculumCodePrefix(objectives.actitud) });
  }

  return items;
}
